<template>
  <!-- z-index 300 to cater for safari bug -->
  <v-combobox
    label="Organization"
    :loading="loading"
    :search-input.sync="organizationName"
    :items="organizations"
    item-text="name"
    item-value="id"
    return-object
    :color="themes.candidate.light.input"
    :value="value"
    no-filter
    hide-no-data
    clearable
    :required="required"
    :rules="rules || []"
    :disabled="disabled"
    @input="handleInput"
    menu-props="closeOnClick"
    :style="toFront ? 'z-index: 300' : ''"
    attach
  >
    <template slot="item" slot-scope="{ item: organization }">
      <v-list-tile-avatar>
        <img :src="organization.logo" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ organization.name }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="organization.industry">
          {{ organization.industry }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="selection" slot-scope="{ item: organization }">
      <slot name="selection" v-bind:organization="organization">
        <v-chip v-if="organization.name">
          <v-avatar v-if="organization.logo">
            <img :src="organization.logo" />
          </v-avatar>
          {{ organization.name }}
        </v-chip>
      </slot>
    </template>
  </v-combobox>
</template>

<script>
// Helpers
import _ from 'lodash'

// Vue Component
export default {
  props: {
    required: { type: Boolean, default: () => false },
    rules: { type: Array },
    toFront: { type: Boolean, default: () => true },
    value: { required: true },
    disabled: { type: Boolean, default: () => false },
  },
  data() {
    return {
      loading: false,
      organizationName: `${this.value.name}`,
      organizations: [],
    }
  },
  watch: {
    organizationName: _.debounce(function(organization) {
      // organization is null on initial load
      if (organization && organization.length > 2) {
        // Update options
        this.loading = true
        Vue.$http
          .get(`candidate/experience_organizations?search=${organization}`)
          .then(response => {
            this.organizations = response.data
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.loading = false))
      } else {
        this.organizations = []
      }
    }, 150),
  },
  methods: {
    handleInput(organization) {
      if (organization) {
        if (organization.name) {
          this.$emit('input', organization)
        } else {
          this.$emit('input', { name: organization })
        }
      }
    },
  },
}
</script>
